module.exports = __webpack_public_path__ + "908e4d2e/img/ion_calendar-number.3ac5bd07.svg";